export interface FeatureAccess {
  scene: boolean;
  splat: boolean;
  ortho: boolean;
  video360: boolean;
  matterport: boolean;
  basemap: boolean;
}

export interface AccessSubject {
  role?: string | null;
  permissions?: {
    sceneVisible?: boolean;
    gaussianVisible?: boolean;
    orthomosaicVisible?: boolean;
    video360Visible?: boolean;
    matterportVisible?: boolean;
    basemapVisible?: boolean;
  } | null;
}

export const NO_ACCESS: FeatureAccess = { scene: false, splat: false, ortho: false, video360: false, matterport: false, basemap: false };

// Mirrors backend/src/utils/access.ts — keep the two in step. Pages and the
// Scene read these flags, never user.permissions directly.
export const accessOf = (subject: AccessSubject | null | undefined): FeatureAccess => {
  if (subject?.role === 'superadmin') {
    return { scene: true, splat: true, ortho: true, video360: true, matterport: true, basemap: true };
  }
  const p = subject?.permissions ?? {};
  return {
    scene: !!p.sceneVisible,
    splat: !!p.gaussianVisible,
    ortho: !!p.orthomosaicVisible,
    video360: !!p.video360Visible,
    matterport: !!p.matterportVisible,
    basemap: !!p.basemapVisible,
  };
};

export type SceneLayerKind = 'splat' | 'ortho' | 'drawing';

// What may be drawn inside the Scene. BIM and drawings need no permission
// beyond the Scene itself.
export const sceneLayerAllowed = (kind: SceneLayerKind | null, access: FeatureAccess): boolean => {
  if (kind === 'splat') return access.splat;
  if (kind === 'ortho') return access.ortho;
  return kind === 'drawing';
};

// Project sections a user sees (project page cards, sidebar, section pages).
export const sectionAllowed = (path: string, access: FeatureAccess): boolean => {
  if (path === 'gaussian') return access.splat;
  if (path === 'orthomosaic') return access.ortho;
  if (path === 'video360') return access.video360;
  return true;
};
